<template>
  <div>
    <label v-if="label !== null">{{ label }}</label>
    <div class="dropdown">
      <button
          type="button" class="dropdown-toggle" data-toggle="dropdown"
          :class="[buttonClass]"
          :style="{'padding': buttonPadding, 'margin': buttonMargin}"
          :disabled="disabled">
        {{ showLabel ? selectedOption.label : selectedOption.value }}
      </button>
      <div class="dropdown-menu" :style="{'margin':buttonDropdownMargin}">
        <a
            class="dropdown-item"
            href="#" v-for="(option, index) in input_options"
            :key="'item_'+index"
            @click.prevent="onClick(option)">
          <template v-if="!hasSlotLabel">
            {{ option.label }}
          </template>
          <slot name="optionLabel" :option="option"></slot>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import Vuex from 'vuex'
import {selectorMixin} from './../mixins/index.js';

export default {
  name: "single-select-button",
  mixins: [selectorMixin],
  props: {
    value: {},
    disabled: {
      type: Boolean,
      default: false
    },
    showLabel: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: null
    },
    options: {
      default: () => []
    },
    optionValue: {
      type: String,
      default: null
    },
    optionLabel: {
      type: String,
      default: null
    },
    optionFilter: {
      default: null
    },
    buttonClass: {
      default: "btn btn-primary"
    },
    buttonPadding: {
      default: ""
    },
    buttonMargin: {
      default: ""
    },
    buttonDropdownMargin: {
      default: ""
    }
  },
  watch: {
    value: function (newVal, oldVal) {
      if(JSON.stringify(newVal) != JSON.stringify(this.cValue)){
        this.cValue = JSON.parse(JSON.stringify(newVal));
      }
      this.setSelectedOption(newVal);
    }
  },
  computed: {
    hasSlotLabel() {
      return !!this.$slots.optionLabel;
    },
    input_options() {
      try {
        let options = this.providerOptions.map((option, index) => {
          let adittionalParams = {
            enabled: typeof option.__enabled !== 'undefined' ? option.__enabled : true,
            index: index
          };
          if (typeof option === 'object' && (option.value != undefined && option.label != undefined)) {
            return {...option, ...adittionalParams};
          } else if (typeof option === 'object' && (this.optionLabel !== null && this.optionValue !== null)) {
            return {value: option[this.optionValue], label: option[this.optionLabel], ...adittionalParams};
          } else {
            return {value: option, label: option, ...adittionalParams};
          }
        });
        return options;
      } catch (err) {
        return [];
      }
    },
  },
  mounted() {
    if (typeof this.value !== 'undefined') this.setSelectedOption(this.value);
    this.$emit('onMounted', this);
  },
  methods: {
    onClick(option) {
      this.selectedOption = option;
      this.$emit('input', option.value);
      this.$emit('onChange', this);
    },
    setSelectedOption(value) {
      this.selectedOption = this.input_options.filter(o => o.value == value)[0] || {value: null, label: null};
    },
  },
  data() {
    return {
      cValue: this.value ? JSON.parse(JSON.stringify(this.value)) : null,
      selectedOption: {value: null, label: null}
    }
  }
}
</script>
<style scoped>

</style>
